import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { ClipLoader } from "react-spinners";
import Layout from "../../components/layout/Layout";
import Navbar from "../../components/layout/header/Navbar";
import Footer from "../../components/layout/footer/Footer";
import PageHeader from "../../components/team/PageHeader";
import axiosClient from "../../api/axios";
import NotFoundPage from "../not-found/NotFoundPage";
import "./AffiliationDetail.css";

export default function AffiliationDetail({ information }) {
  const { slug } = useParams();
  const [affiliation, setAffiliation] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setLoading(true);
    setNotFound(false);
    axiosClient
      .get(`/api/affiliations/slug/${slug}/`)
      .then((r) => setAffiliation(r.data.data))
      .catch(() => setNotFound(true))
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading) {
    return (
      <Layout>
        <Navbar darkBg information={information} />
        <section style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "60vh" }}>
          <ClipLoader color="#0d6efd" size={80} />
        </section>
        <Footer space information={information} />
      </Layout>
    );
  }
  if (notFound) return <NotFoundPage information={information} />;

  return (
    <Layout>
      <Navbar darkBg information={information} />
      <PageHeader
        HeaderTitle={affiliation.title}
        Parent="Our Partners"
        PageTitle="Affiliation Details"
      />

      <section className="ptb-60">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <h2 className="mb-2">{affiliation.title}</h2>
              <h3 className="mb-4">{affiliation.subtitle}</h3>

              {affiliation.banner_image_url && (
                <div className="mb-5">
                  <img
                    src={affiliation.banner_image_url}
                    alt={affiliation.title}
                    className="img-fluid rounded shadow-sm w-100"
                  />
                </div>
              )}

              {affiliation.sections.map((section, idx) => (
                <div key={idx} className="mb-5">
                  <h4 className="mb-3">{section.title}</h4>
                  {section.paragraphs.map((para, pi) => (
                    <p
                      key={pi}
                      className="affiliation-paragraph lead"
                      dangerouslySetInnerHTML={{ __html: para.replace(/\n/g, "<br>") }}
                    />
                  ))}
                  {section.items.length > 0 && (
                    <ul style={{ fontSize: "1.05rem", listStyleType: "disc", paddingLeft: "1.5rem" }}>
                      {section.items.map((item, ii) => (
                        <li key={ii}>{item}</li>
                      ))}
                    </ul>
                  )}
                </div>
              ))}

              {affiliation.physicians.length > 0 && (
                <div className="mb-4">
                  <h4 className="mb-4">Affiliated Physician{affiliation.physicians.length > 1 ? "s" : ""}</h4>
                  {affiliation.physicians.map((physician, pi) => (
                    <div key={pi} className="mb-5">
                      {physician.image_url ? (
                        <div className="row align-items-start g-4">
                          <div className="col-md-5">
                            <img
                              src={physician.image_url}
                              alt={`Portrait of ${physician.name}`}
                              className="img-fluid rounded shadow-sm w-100 h-100"
                              style={{ minHeight: "300px", objectFit: "cover" }}
                            />
                          </div>
                          <div className="col-md-7">
                            <h5 className="mb-1">{physician.name}</h5>
                            <p className="mb-3" style={{ fontWeight: 500 }}>{physician.role}</p>
                            {physician.bio_paragraphs.map((para, bi) => (
                              <p
                                key={bi}
                                style={{ fontSize: "1.05rem" }}
                                className={`affiliation-paragraph${bi === physician.bio_paragraphs.length - 1 ? " mb-0" : ""}`}
                                dangerouslySetInnerHTML={{ __html: para.replace(/\n/g, "<br>") }}
                              />
                            ))}
                          </div>
                        </div>
                      ) : (
                        <>
                          <h5 className="mb-1">{physician.name}</h5>
                          <p className="mb-3" style={{ fontWeight: 500 }}>{physician.role}</p>
                          {physician.bio_paragraphs.map((para, bi) => (
                            <p
                              key={bi}
                              style={{ fontSize: "1.05rem" }}
                              className={bi === physician.bio_paragraphs.length - 1 ? "mb-0" : ""}
                              dangerouslySetInnerHTML={{ __html: para.replace(/\n/g, "<br>") }}
                            />
                          ))}
                        </>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      <Footer space information={information} />
    </Layout>
  );
}
